import { useCallback, useEffect } from 'react';
import useMarketPagination from 'hooks/useMarketPagination';
import useMarketAutoRefresh from './useMarketAutoRefresh';
import useMarketInput from './useMarketInput';

/**
 *
 * @param refetchResults Function to refetch market results
 * @returns onRefetchResults function to reset pagination and set load time
 */
const useMarketRefetchResults = (refetchResults: () => void) => {
  const { onSetLoadTime } = useMarketAutoRefresh(refetchResults);
  const { onResetPagination } = useMarketPagination();
  const { marketInput } = useMarketInput();

  const handleResetResults = useCallback(() => {
    onResetPagination();
    onSetLoadTime();
  }, [onResetPagination, onSetLoadTime]);

  //If any input changes requery
  useEffect(() => {
    handleResetResults();
  }, [
    marketInput?.filters,
    marketInput?.method,
    marketInput?.search,
    marketInput?.truckTypeUUID,
    marketInput?.buyerID,
    marketInput?.groupOption,
    marketInput?.metric,
    handleResetResults,
  ]);

  return { onRefetchResults: handleResetResults };
};

export default useMarketRefetchResults;
